import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import ContactTopic from './ContactTopic';

const SECTION_PREFIX = 'portal-contact';
const HIDDEN_DIV_TEMPLATE = '<div class="hidden"></div>';
const LIVEPERSONCHAT_DIV_TEMPLATE = '<div class="modLivePersonChat" id="lpChatContactButton"></div>';

declare global {
	interface Window { lpTag : any; }
}

export default class LivePersonChatForContact extends Module {
	private topicId! : string;
	private $chatButton! : JQuery;

	public on(callback : Hook) {
		this.topicId = this.$ctx.closest('.result[data-parent-topic]').attr('data-parent-topic') as string;

		this.$chatButton = $(document.body).find('#lpChatContactButton');
		if (!this.$chatButton.length) {
			const $hiddenDiv = $(HIDDEN_DIV_TEMPLATE);
			this.$chatButton = $(LIVEPERSONCHAT_DIV_TEMPLATE);

			this.$chatButton.appendTo($hiddenDiv);
			$hiddenDiv.appendTo(document.body);
		}

		callback();
	}

	public onTopicSelected(topic : ContactTopic) {
		if (topic.topicName !== this.topicId && (topic as any).name !== this.topicId) {
			return;
		}

		const name = topic.topicName || (topic as any).name;
		const topicName = name.split('/');
		const topicSection = `${SECTION_PREFIX}:topic:${topicName[0]}`;
		const subtopicSection = `${SECTION_PREFIX}:subtopic:${topicName[1]}`;

		if(window.lpTag) {
			let sections = window.lpTag.section || [];
			sections = sections.filter((section : any) => {
				if(typeof section !== 'string') {
					return true;
				}
				section = section.split(':');

				return section[0] !== SECTION_PREFIX;
			});
			sections.push(topicSection, subtopicSection);
			if(window.lpTag.newPage) {
				window.lpTag.newPage(window.location.href, {section: sections});
			} else {
				window.lpTag.section = sections;
			}
		} else {
			window.lpTag = {section: [topicSection, subtopicSection]};
		}
		this.$chatButton.attr('data-track-linkname', this.$ctx.data('track-linkname'));
		this.$chatButton.attr('data-track-action', this.$ctx.data('track-action'));
		this.$chatButton.attr('data-track-label', this.$ctx.data('track-label'));
		this.$chatButton.attr('data-track-location', this.$ctx.data('track-location'));
		this.$chatButton.attr('data-track-category', this.$ctx.data('track-category'));
		this.$chatButton.attr('data-conversion-category', this.$ctx.data('conversion-category'));
		this.$chatButton.attr('data-conversion-detail', this.$ctx.data('conversion-detail'));
		this.$chatButton.attr('data-conversion-class', this.$ctx.data('conversion-class'));

		this.$chatButton.appendTo(this.$ctx);
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/contact/Tc.Module.LivePersonChatForContact.ts